import CycleChangeML from './CycleChangeML.jsx';
export default (props) => {
  return <CycleChangeML {...props} />;
};
